import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { User } from '../models/user';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class MeService {
  private readonly currentUserSubject = new BehaviorSubject<User | null>(null);
  readonly currentUser$: Observable<User | null> = this.currentUserSubject.asObservable();

  constructor(private readonly storageService: StorageService) {}

  get currentUser(): User | null {
    return this.currentUserSubject.value;
  }

  setCurrentUser(user: User | null): void {
    this.currentUserSubject.next(user);
  }

  reset(): void {
    this.currentUserSubject.next(null);
  }

  isAuthenticated(): boolean {
    return Boolean(this.storageService.get('access_token'));
  }

  hasAnyRole(roles: string[]): boolean {
    const currentUser = this.currentUserSubject.value;
    return Boolean(currentUser?.roles.some((role) => roles.includes(role)));
  }
}
